import { Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { getFormattedDateWithTime } from '@/utils/date'
import { AiBridgeOperation } from './useAiBridgeOperationLog'
import { AI_BRIDGE_TEST_RESULT_COLOR } from './useAiBridgeTest'

type AiBridgeLastOperationProps = {
  operation?: AiBridgeOperation
}

export const AiBridgeLastOperation = ({
  operation
}: AiBridgeLastOperationProps) => {
  if (!operation) {
    return (
      <Text size="xs" c="dimmed">
        <FormattedMessage id="aiBridge.fields.lastOperation.never" />
      </Text>
    )
  }

  return (
    <Stack gap={0}>
      <Text size="xs">
        <FormattedMessage id={`aiBridge.operation.${operation.type}`} />
        {` — ${getFormattedDateWithTime(operation.at)}`}
      </Text>

      {/* Device errors come through verbatim and can be long, so cap the height. */}
      <Text
        size="xs"
        c={AI_BRIDGE_TEST_RESULT_COLOR[operation.status]}
        lineClamp={2}
      >
        {operation.message}
      </Text>
    </Stack>
  )
}
